<ion-content [fullscreen]="true" *ngIf="provider$ | async as provider">

  <app-header style="z-index:10000" [provider]="provider"></app-header>

  <ng-container *ngIf="service$ | async as service; else skeleton">

    <div class="content nopadding">
      <div class="bigblock blue">
        <div class="vertical">{{service?.field}}</div>
        <ng-template #hideService>
          <div class="text">
            <h1>Te storitve ni več na voljo</h1>
          </div>
        </ng-template>

        <div class="text" *ngIf="service.visibleForCustomers; else hideService">
          <h1 [ngClass]="{'long':(service?.name?.length||0>80),'medium':(service?.name?.length||0>40)}">{{service?.name}}</h1>
          <div class="priceblock">
            <ng-container
              *ngIf="(service?.loyaltyCycleDiscountPercentage || 0)>0 && (loyaltyCycleDiscountedPrice || 0)>0;else regularPrice">
              <div class="discount">{{ service?.getHigherPrice(service?.regularPrice1) }} EUR
                <span *ngIf="service.loyaltyCycle"
                  appTooltip="Skrajni čas za izkoristek popusta za zveste stranke:<br> {{service.loyaltyExpirationDate}}"
                  style="display: inline-block;z-index: 2;">ⓘ</span>
              </div>
              <div class="price"><i>{{loyaltyCycleDiscountedPrice | currency: 'EUR':'':'1.2-2':'sl'}}</i> EUR
                <div class="clock">
                  {{service?.duration}}'
                </div>
              </div>

            </ng-container>
            <ng-template #regularPrice>
              <div class="discount" *ngIf="service?.isDiscountAvailable()">{{ service?.getHigherPrice(service?.regularPrice1) }} EUR </div>
              <div class="price"><i>{{service?.minimalPrice?.lowestPrice | currency: 'EUR':'':'1.2-2':'sl'}}</i> EUR
                <div class="clock">
                  {{service?.duration}}'
                </div>
              </div>

            </ng-template>

          </div>
          <div class="c"></div>
          <a (click)="$event.stopPropagation(); cartService.addService( service)" class="clickable shop mt-30"><b></b>DODAJ V KOŠARICO</a>
          <div class="clickable mobileshop mt-30">
            <ion-fab *ngIf="!!service?.name">
              <ion-fab-button id="mobileshop_fab">
                <div class="inner" *ngIf="cartService.getAttendeeSize()===0"
                  (click)="$event.stopPropagation();cartService.addService(service!);animateAddToCart()">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                      fill="white" />
                  </svg>
                </div>
                <div class="inner" *ngIf="cartService.getAttendeeSize()!==0">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                      fill="white" />
                  </svg>
                </div>
              </ion-fab-button>
              <ion-fab-list side="bottom">
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,1 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=1">
                  Oseba 1
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,2 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=2">
                  Oseba 2
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,3 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=3">
                  Oseba 3
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,4 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()==4">
                  Oseba 4
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addAttendee();cartService.addService(service!)"
                  *ngIf="cartService.getAttendeeSize()<4">
                  <ion-icon name="add-outline"></ion-icon> Dodaj osebo
                </ion-fab-button>
              </ion-fab-list>

            </ion-fab>
            <span *ngIf="cartService.getAttendeeSize()!==0" (click)="triggerElementClick('mobileshop_fab');animateAddToCart()">
              DODAJ V KOŠARICO
            </span>
            <span *ngIf="cartService.getAttendeeSize()===0"
              (click)="$event.stopPropagation();cartService.addService(service!);animateAddToCart()">
              DODAJ V KOŠARICO
            </span>
          </div>

          <div class="mt-30 available-in">
            <ul>
              <li *ngFor="let real of provider.reals" class="clickable">
                <b [routerLink]="['/','salon',real.slug]">
                  <a href="/salon/{{real.slug}}">
                    {{real.name}}
                  </a>
                </b>
              </li>
            </ul>
          </div>

        </div>
        <img src="{{service?.avatar?.url || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"
          alt="{{service?.field}} - {{service?.name}} - {{service?.longDescription}} | dm Studio">
      </div>
    </div>

    <div class="content" *ngIf="service.visibleForCustomers">
      <div class="textblock mt-50 mb-50 preformatted-text">
        {{service?.longDescription}}
      </div>
    </div>

    <div class="content nopadding"
      *ngIf="(service?.gallery && service.gallery?.length && (service.gallery?.length || 0) > 0) && service.visibleForCustomers">
      <div class="galerija mt-50 mb-50">
        <h2 style="text-transform: unset!important;">GALERIJA</h2>
        <div class="inner" #servicegalleryslider>
          <div class="item clickable" *ngFor="let img of service?.gallery;index as i" (click)="openLightbox3(i)"><img [src]="img.url"
              alt="">
            <div class="lupe clickable"></div>
          </div>
        </div>
        <div class="next" [ngClass]="{'hidden':((service.gallery?.length ||0 )<=5)}" (click)="slideRight()"></div>
        <div class="prev" [ngClass]="{'hidden':((service.gallery?.length ||0 )<=5)}" (click)="slideLeft()"></div>

      </div>
    </div>

    <div class="content nopadding" *ngIf="service && service?.recommendations && service.recommendations.length>0">
      <div class="items mt-50">
        <h2 class="mb-50">PRIPOROČENE STORITVE</h2>
        <div class="flex">
          <app-service-card *ngFor="let item of service.recommendations | onlyServices " class="item"
            [style.border-color]="item.borderColor" [style.--bg-color]="item.borderColor + '2A'" [service]="item"
            [recommendedDiscount]="(cartService.getTotalItemsInCart() == 1 && (cartService.getTotal()>0) && (item.discount>0 || provider.recommendationsDiscount>0)) ? item.recommendationDiscount(provider) : 0"></app-service-card>
        </div>
      </div>
    </div>

    <app-gallery-lightbox></app-gallery-lightbox>
    <app-json-ld [itemLD]="jsonLD"></app-json-ld>


    <!--TODO remove for now, will be added later-->
    <!-- <div class="content nopadding">
    <div class="aktualno center mt-50">
      <div class="spacer_2"></div>
      <h2>POVEZANI ČLANKI</h2>
      <div class="item center"><div class="img"><img src="assets/img/img_2.png"></div><i>NEGA KOŽE</i><b>Paž frizure 2023: sveže ideje za preobrazbo</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
    </div>
  </div> -->

    <div class="spacer_1 mt-50"></div>

    <ng-container *ngIf="abilities$ | async as abilities">
      <div class="content nopadding" *ngIf="filteredEmployees as employees">
        <div class="zaposleni">
          <h2 class="mb-50">ZAPOSLENI</h2>
          <div class="flex">

            <ng-container *ngFor="let employee of employees">
              <a href="/zaposleni/{{employee[1].slug}}">
                <div class="item" [routerLink]="['/','zaposleni',employee[1].slug]">
                  <img src="{{employee[1].avatarUrl() }}" loading="lazy" alt="{{employee[1].name}} - {{employee[2]}} | Ekipa dm Studio">
                  <b>{{employee[1].name}}</b>
                  <span>{{employee[2]}}</span>
                </div>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="content" *ngIf="service?.children?.length === 0 && service.visibleForCustomers">
      <div class="midblock full mt-50 mb-30">
        <div class="text">
          <b>REZERVIRAJ TERMIN</b>
          <span>{{service.name}}</span>
          <div class="c"></div>
          <ng-container *ngIf="(service?.loyaltyCycleDiscountPercentage || 0)>0 && loyaltyCycleDiscountedPrice>0;else regularPrice2">
            <div class="priceblock mt-30 mb-30">
              <div class="discount">{{ service?.getHigherPrice(service?.regularPrice1) }} EUR</div>
              <div class="price"><i>{{loyaltyCycleDiscountedPrice | currency: 'EUR':'':'1.2-2':'sl'}}</i> EUR</div>
            </div>
            <span style="font-size: 1em;color:grey" *ngIf="service.loyaltyCycle">ⓘ Skrajni čas za izkoristek popusta za zveste stranke:<br>
              {{service.loyaltyExpirationDate}}
            </span>
          </ng-container>
          <ng-template #regularPrice2>
            <div class="priceblock mt-30 mb-30">
              <div class="discount" *ngIf="service?.isDiscountAvailable()">{{ service?.getHigherPrice(service?.regularPrice1) }} EUR</div>
              <div class="price"><i>{{service?.minimalPrice?.lowestPrice | currency: 'EUR':'':'1.2-2':'sl'}}</i> EUR</div>
            </div>
          </ng-template>




          <div class="c"></div>
          <a *ngIf="service.visibleForCustomers" class="shop clickable"
            (click)="$event.stopPropagation();cartService.addService( service! )"><b></b>DODAJ V KOŠARICO</a>

          <div class="clickable mobileshop mt-30">
            <ion-fab *ngIf="!!service?.name" style="left:0">
              <ion-fab-button id="mobileshop_fab2">
                <div class="inner" *ngIf="cartService.getAttendeeSize()===0"
                  (click)="$event.stopPropagation();cartService.addService(service!);animateAddToCart()">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                      fill="white" />
                  </svg>
                </div>
                <div class="inner" *ngIf="cartService.getAttendeeSize()!==0">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                      fill="white" />
                  </svg>
                </div>
              </ion-fab-button>
              <ion-fab-list side="bottom">
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,1 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=1">
                  Oseba 1
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,2 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=2">
                  Oseba 2
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,3 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()>=3">
                  Oseba 3
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( service!,4 );animateAddToCart()"
                  *ngIf="cartService.getAttendeeSize()==4">
                  Oseba 4
                </ion-fab-button>
                <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addAttendee();cartService.addService(service!)"
                  *ngIf="cartService.getAttendeeSize()<4">
                  <ion-icon name="add-outline"></ion-icon> Dodaj osebo
                </ion-fab-button>
              </ion-fab-list>

            </ion-fab>
            <span *ngIf="cartService.getAttendeeSize()!==0" (click)="triggerElementClick('mobileshop_fab2')">
              DODAJ V KOŠARICO
            </span>
            <span *ngIf="cartService.getAttendeeSize()===0" (click)="$event.stopPropagation();cartService.addService(service!)">
              DODAJ V KOŠARICO
            </span>
          </div>
        </div>
      </div>
    </div>

    <!--div class="content nopadding">
    <div class="items">
      <h2 class="mb-50">PRIPOROČENE STORITVE</h2>
      <ion-button id="open-modal" expand="block">Open</ion-button>

    </div>
  </div-->


  </ng-container>

  <ng-template #skeleton>
    <div class="content nopadding">
      <div class="bigblock blue">
        <div class="vertical"><ion-skeleton-text [animated]="true"></ion-skeleton-text></div>
        <div class="text">
          <h2><ion-skeleton-text [animated]="true" style="height:255px;width:100%;max-width:90%;"></ion-skeleton-text></h2>
          <div class="priceblock">
            <div class="discount"><ion-skeleton-text [animated]="true"></ion-skeleton-text></div>
            <div class="price"><i><ion-skeleton-text [animated]="true"></ion-skeleton-text></i> EUR<div class="clock"></div>
            </div>
          </div>
          <div class="c"></div>
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </div>
        <ion-skeleton-text [animated]="true" style="height:514px;width:50%;position: absolute;bottom: 0;right: 0;"></ion-skeleton-text>
      </div>
    </div>

    <div class="content">
      <div class="textblock mt-50 mb-50">
        <ion-skeleton-text [animated]="true" style="width: 100%;height: 3em;"></ion-skeleton-text>
      </div>
    </div>

    <div class="content">
      <div class="items">
        <h2 class="mb-50">PRIPOROČENE STORITVE</h2>
        <div class="flex">
          <ion-skeleton-text [animated]="true" style="width:22%;height:400px" class="item"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width:22%;height:400px" class="item"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width:22%;height:400px" class="item"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width:22%;height:400px" class="item"></ion-skeleton-text>
        </div>
      </div>
    </div>

  </ng-template>

  <app-footer [provider]="provider"></app-footer>

  <app-cart [provider]="provider"></app-cart>

</ion-content>